import { TitleCasePipe } from '@angular/common';
import { AfterContentInit, Component, ElementRef, Input, OnChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BreadCrumb, Category, ProductDetails } from 'src/app/models';
import { CategoryService } from 'src/app/services/category/category.service';
import { ContentService, sections } from 'src/app/services/content/content.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { ContentSection } from '../../layout/content-section';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, RouterLink, TitleCasePipe],
})
export class BreadcrumbComponent extends ContentSection implements AfterContentInit, OnChanges {
  private route = inject(ActivatedRoute);
  private categoryService = inject(CategoryService);
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);

  @Input() categoryId: number;
  @Input() product: ProductDetails;

  groceries: string;
  isDagrofa: boolean;

  breadcrumbs: BreadCrumb[] = [];

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, sections.header);

    this.groceries = this.content.get('groceries');

    this.isDagrofa = this.contentService.isDagrofa;
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }

  ngOnChanges() {
    this.breadcrumbs = this.buildBreadCrumb(this.categoryId);
  }

  buildBreadCrumb(categoryId?: number): BreadCrumb[] {
    const path = this.route.parent.routeConfig ? this.route.parent.routeConfig.path : '';
    const url = `/${path}`;

    let breadcrumbs: BreadCrumb[] = [];

    if (this.groceries) {
      breadcrumbs = [...breadcrumbs, { label: this.groceries, url }];
    }

    if (this.isDagrofa) {
      breadcrumbs = [{ label: 'Forside', url: '/' }, ...breadcrumbs];
    }

    // Set Category
    const categoryBreadCrumb = this.buildCategoryBreadcrumb(categoryId, url);

    if (categoryBreadCrumb?.length) {
      breadcrumbs = [...breadcrumbs, ...categoryBreadCrumb];
    }

    // Set Product
    if (this.product) {
      const productBreadCrumb: BreadCrumb = {
        label: this.product.productDisplayTitle || this.product.productDisplayName,
        url: null, // or use this.productService.createProductUrl(this.product),
      };

      breadcrumbs = [...breadcrumbs, productBreadCrumb];
    }

    // Reverse to make up for dir="rtl" changing the order
    return breadcrumbs.reverse();
  }

  private buildCategoryBreadcrumb(categoryId: number, url: string): BreadCrumb[] {
    if (!categoryId) {
      return null;
    }

    let categoryNode = this.categoryService.getById(categoryId);
    if (!categoryNode) {
      console.warn('Product category not recognized: ', categoryId);
      return undefined;
    }

    const categories: Category[] = [];
    while (categoryNode) {
      categories.unshift(categoryNode.data);
      categoryNode = categoryNode.parent;
    }

    let breadcrumbs: BreadCrumb[] = [];
    for (const category of categories) {
      const url = this.categoryService.buildUrl(category.id);

      const breadcrumb = {
        label: category.name,
        url,
      };

      breadcrumbs = [...breadcrumbs, breadcrumb];
    }

    return breadcrumbs;
  }
}
